import script from "./SwitchLg.vue?vue&type=script&setup=true&lang=js"
export * from "./SwitchLg.vue?vue&type=script&setup=true&lang=js"

import "./SwitchLg.vue?vue&type=style&index=0&id=6d5075c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d5075c4"]])

export default __exports__